import convertDate from './convertDate'
import convertTime from './convertTime'

export default {
	convertDate,
	convertTime,
	retornarIcone(ativo) {
		if (ativo) return 'mdi-check'
		else return 'mdi-close'
	},
	formatarCpfCnpj(value) {
		if (value) {
			if (value.length < 15) {
				return '###.###.###-##'
			} else {
				return '##.###.###/####-##'
			}
		}
	},
	formatarTelefone(telefone) {
		if (telefone) {
			if (telefone.length < 15)
				return '(##) ####-####'
			else return '(##) # ####-####'
		}
	}
}
